// extracted by mini-css-extract-plugin
export default {"container":"ExerciseViewer_container__XgBRU"};